import React, { type Element, useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import './BottomDrawerModal.scss';
// eslint-disable-next-line import/no-named-as-default
import Options from './Options';

export type BottomDrawerModalProps = {
  open: Boolean,
  optionProps: any,
  closeDrawer: (state: Boolean) => void,
};

export const BottomDrawerModal = (props: BottomDrawerModalProps): Element<"div"> => {
  const { closeDrawer, optionProps } = props;
  const [openOptions, setOpenOptions] = useState(false);
  const domNode = document.getElementsByClassName('site-container')[0];
  useEffect(() => {
    setTimeout(() => setOpenOptions(props.open), 0);
    if (props.open) {
      domNode.style.overflow = 'hidden';
    } else {
      domNode.style.overflow = 'auto';
    }
  }, [props.open]);

  const closeModal = () => {
    setOpenOptions(false);
    setTimeout(() => closeDrawer(false), 600);
    domNode.style.overflow = 'auto';
  };
  return props.open ?
    // eslint-disable-next-line function-paren-newline
    createPortal(
      <div className="bottom-drawer">
        <div className="drawer-backdrop" />
        <div
          className={classNames('drawer-content', {
            open: openOptions,
          })}
        >
          <div className="close-modal">
            <div className="drawer-header">
              <div className="drawer-header-title">
                Sort
              </div>
              <i className="icon icon-close" role="button" tabIndex={0} onClick={closeModal} onKeyDown={closeModal} />
            </div>
          </div>
          <Options closeFilter={closeModal} {...optionProps} />
        </div>
      </div>, domNode) : null;
};

export default BottomDrawerModal;



// WEBPACK FOOTER //
// ./src/modules/home/modules/browser/home/BusinessList/components/BottomDrawerModal.js